export enum SurfErrorCode {
  INVALID_CONFIG = "INVALID_CONFIG",
  MISSING_PROJECT_ID = "MISSING_PROJECT_ID",
  INVALID_APP_ID = "INVALID_APP_ID",
  INVALID_ENVIRONMENT = "INVALID_ENVIRONMENT",
  UNSUPPORTED_CHAIN = "UNSUPPORTED_CHAIN",
  ENVIRONMENT_CHAIN_MISMATCH = "ENVIRONMENT_CHAIN_MISMATCH",
  WALLET_NOT_INSTALLED = "WALLET_NOT_INSTALLED",
  WALLET_NOT_CONNECTED = "WALLET_NOT_CONNECTED",
  WALLET_REJECTED = "WALLET_REJECTED",
  WRONG_CHAIN = "WRONG_CHAIN",
  AUTH_FAILED = "AUTH_FAILED",
  SIGNATURE_REJECTED = "SIGNATURE_REJECTED",
  VAULT_NOT_FOUND = "VAULT_NOT_FOUND",
  VAULT_ALREADY_EXISTS = "VAULT_ALREADY_EXISTS",
  VAULT_DEPLOY_FAILED = "VAULT_DEPLOY_FAILED",
  INSUFFICIENT_BALANCE = "INSUFFICIENT_BALANCE",
  APPROVE_FAILED = "APPROVE_FAILED",
  DEPOSIT_FAILED = "DEPOSIT_FAILED",
  WITHDRAW_FAILED = "WITHDRAW_FAILED",
  NO_BEST_VAULT = "NO_BEST_VAULT",
  API_ERROR = "API_ERROR",
  RPC_ERROR = "RPC_ERROR",
  TRANSACTION_FAILED = "TRANSACTION_FAILED",
}

export class SurfError extends Error {
  constructor(
    public readonly code: SurfErrorCode,
    message: string,
    public readonly cause?: unknown,
  ) {
    super(message);
    this.name = "SurfError";
  }
}
